import { render, staticRenderFns } from "./registeredKioskList.vue?vue&type=template&id=06f8330a"
import script from "./registeredKioskList.vue?vue&type=script&lang=js"
export * from "./registeredKioskList.vue?vue&type=script&lang=js"
import style0 from "./registeredKioskList.vue?vue&type=style&index=0&id=06f8330a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports